import { Directive, HostListener, inject, Input, ElementRef } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';

@Directive({
  selector: '[gtmClick]',
  exportAs: 'gtmClick',
})
export class GtmClickDirective {
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private elementRef = inject(ElementRef);

  @Input('gtmClick') gtmName: string;
  @Input() gtmEventCategory: string = 'click';
  @Input() gtmClaimType?: string;
  @Input() gtmLinkURL?: string;
  @Input() gtmLinkClasses?: string;

  @HostListener('click') click() {
    // Use gtmLinkClasses to send different information or leave empty to get the css classes
    const classes = this.gtmLinkClasses || this.getElementClasses(this.elementRef.nativeElement);

    // Remove HTML tags from gtmName before passing it to the analytics service
    const cleanGtmName = this.removeHtmlTags(this.gtmName);

    this.googleAnalyticsService.emitClickEvent(this.gtmEventCategory, cleanGtmName, this.gtmLinkURL, classes, this.gtmClaimType);
  }

  getElementClasses(element: HTMLElement): string {
    if (!element) {
      return '';
    }

    return element.className || '';
  }

  removeHtmlTags(input: string): string {
    if (!input) {
      return '';
    }
    // Replace all HTML tags with empty string
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }
}
